import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import financeApiService from "../../../../services/financeApiService";
import financeV2Adapters from "../../../../adapters/financeV2Adapters";
import tools from "../../../../helpers/tools";

// LS-623 — écran Encours CB : même mécanique que useFinanceList (filtres
// débouncés + pagination), sur GET /financement/encours (une ligne par
// véhicule financé des demandes Transmis et signé).

// Aligné sur CustomPagination (itemsCountPerPage figé à 15).
const PER_PAGE = 15;

const initialFilters = {
  financeurUuid: "",
  immatriculation: "",
  // "" (tous) / "1" (soldés) / "0" (non soldés).
  solde: "",
  // LS-743 — "" (tous) / "1" (seulement les véhicules vendus, statut flotte
  // 6x, dont le solde n'est pas payé).
  venduNonSolde: "",
};

const initialMeta = {
  current_page: 1,
  per_page: PER_PAGE,
  total: 0,
  last_page: 1,
};

const useEncoursList = () => {
  const [filters, setFilters] = useState(initialFilters);
  const [page, setPage] = useState(1);
  const [encours, setEncours] = useState([]);
  const [meta, setMeta] = useState(initialMeta);
  const [isLoading, setIsLoading] = useState(false);
  const debounceRef = useRef(null);

  const fetchEncours = useCallback(async () => {
    setIsLoading(true);
    try {
      const query = tools.getSearchString({
        ...financeV2Adapters.toApi.filtresEncours(filters),
        par_page: PER_PAGE,
        page,
      });
      const res = await financeApiService.listerEncours(query);
      const items = res.data?.data || [];
      setEncours(items.map(financeV2Adapters.fromApi.encoursItem));
      setMeta(res.data?.meta || { ...initialMeta, current_page: page });
    } catch (err) {
      console.error("Erreur chargement de l'encours", err);
      toast.error("Erreur lors du chargement de l'encours.");
    } finally {
      setIsLoading(false);
    }
  }, [filters, page]);

  // Débounce (350 ms) sur tout changement de filtre ou de page.
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(fetchEncours, 350);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [fetchEncours]);

  const updateFilter = useCallback((key, value) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => {
    setPage(1);
    setFilters(initialFilters);
  }, []);

  return {
    filters,
    updateFilter,
    resetFilters,
    page,
    setPage,
    encours,
    meta,
    isLoading,
  };
};

export default useEncoursList;
